import { render, staticRenderFns } from "./BCXAgbPopup.vue?vue&type=template&id=c7eff9f8"
import script from "./BCXAgbPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXAgbPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXAgbPopup.vue?vue&type=style&index=0&id=c7eff9f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports